import React, { useContext, useState } from "react";
import "./AddRoomGroupModal.css";
import { IoCloseOutline } from "react-icons/io5";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useLanguage } from "../../../../LanguageProvider";
import Services from "../../../../services/Services";
import { GeneralContext } from "../../../../GeneralProvider";
import { useToaster } from "../../../../ToasterProvider";

export default function AddRoomGroupModal({ isOpen, onClose, activeChannel, onGroupAdded }) {
  const { getTranslation } = useLanguage();
  const { toastWarning } = useToaster();
  const [groupTitle, setGroupTitle] = useState("");
  const { getMyChannels } = useContext(GeneralContext);

  if (!isOpen) return null;

  const reset = () => {
    setGroupTitle("");
  };

  const handleCreateGroup = () => {
    if (groupTitle.trim() === "") {
      toastWarning(getTranslation("groupNameCantBeEmpty"));
      return;
    }
    const token = localStorage.getItem("token");
    const existingSettings = activeChannel.settings || {};

    const newGroup = {
      groupID: Date.now().toString(), // basit unique id
      title: groupTitle,
      roomOrder: []
    };

    const updatedSettings = {
      ...existingSettings,
      roomGroups: [
        ...(Array.isArray(existingSettings.roomGroups) ? existingSettings.roomGroups : []),
        newGroup
      ]
    };

    Services.SocialHiveUpdateChannelSettings(token, activeChannel.channelID, updatedSettings)
      .then(() => {
        onGroupAdded(newGroup); // local state güncelle
        getMyChannels();        // ✅ context'teki kanal listesini tazele
        reset();
        onClose();
      });
  };

  return (
    <div className="add-room-modal-overlay">
      <div className="add-room-modal-container">
        <IoCloseOutline className="add-room-modal-button close" onClick={() => { reset(); onClose(); }} />
        <p className="add-room-modal-title">{getTranslation("createGroup")}</p>

        <AddModalInputField
          placeholder={getTranslation("groupName")}
          value={groupTitle}
          onChange={(e) => setGroupTitle(e.target.value)}
          type={"text"}
        />

        <div className="add-room-modal-actions">
          <button onClick={handleCreateGroup} className="add-room-modal-button create">
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}